import { render, staticRenderFns } from "./OptimizerDevPage.vue?vue&type=template&id=f4c7282c&"
import script from "./OptimizerDevPage.vue?vue&type=script&lang=js&"
export * from "./OptimizerDevPage.vue?vue&type=script&lang=js&"
import style0 from "./OptimizerDevPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports